import type { ChangelogEntry } from "../types";

/** Frilanserkortet v2: kontaktpersoner, prosjekter med rolle og en ryddigere logg (VIB-2934). */
export const FRILANSERKORT_V2_2026_10: ChangelogEntry = {
  id: "2026-10-25-frilanserkort-v2",
  date: "2026-10-25",
  title: "Nytt frilanserkort",
  summary:
    "Profilen viser det du trenger for å booke: Ring og E-post øverst, kontaktpersoner som agent og produsent, og prosjektene frilanseren er brukt på med rolle og fakturert beløp.",
  sections: [
    {
      heading: "Frilansere",
      minRole: "user",
      items: [
        {
          title: "Kontaktpersoner",
          kind: "nytt",
          featureFlag: "feature_freelancer_bank",
          body: "Legg til agent, produsent, fakturakontakt eller andre med telefon og e-post. Har frilanseren ikke eget nummer, ringer knappen øverst til agenten.",
        },
        {
          title: "Prosjekter med rolle",
          kind: "nytt",
          featureFlag: "feature_freelancer_projects",
          body: "Prosjektene står i full bredde med kunde, prosjektleder, rolle, estimert kost på linjen, fakturert og antall bilag. Rollen hentes også fra linjene bilagene er fordelt på. En negativ sum er merket «sjekk».",
        },
        {
          title: "Ryddigere toppkort og logg",
          kind: "forbedret",
          featureFlag: "feature_freelancer_bank",
          body: "Toppkortet viser bare nøkkeltallene som finnes. Loggen viser bilder som miniatyrer, og skrivefeltet er én linje til du klikker i det. På mobil ligger Ring og E-post fast nederst.",
        },
      ],
    },
  ],
};
